/** Stored urls are not trusted, so only http(s) becomes a link. Anything else
 * (a `javascript:` url, garbage) renders as plain text. */
export function safeHref(raw: string | undefined): string | undefined {
  if (!raw) return undefined;
  try {
    const { protocol, href } = new URL(raw);
    return protocol === 'http:' || protocol === 'https:' ? href : undefined;
  } catch {
    return undefined;
  }
}
